"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.askForVoucherTool = void 0;
const zod_1 = require("zod");
exports.askForVoucherTool = {
    name: 'askForVoucher',
    description: `MANDATORY: ONLY analyze the LAST/MOST RECENT user message in this conversation turn. COMPLETELY IGNORE all previous conversation history, including any prior voucher requests, mentions, or related discussions.

    STRICT RULE: Only examine the current user input that you are responding to. Do not consider:
    - Previous user messages in conversation history
    - Earlier voucher requests that may have been processed
    - Past mentions of discounts, coupons, or promotional codes
    - Any historical context about vouchers from prior conversation turns

    ONLY TRIGGER when the CURRENT/LATEST user message contains:
    - Direct requests for vouchers, coupons, or discount codes specifically
    - Mentions of promotional codes or promo codes
    - Explicit requests for discounts or money-off deals
    - Context suggesting the user wants financial assistance through discounts/vouchers
    - Questions specifically about available vouchers or discount coupons

    DO NOT TRIGGER this tool for (use other appropriate tools):
    - Contact requests or wanting to get in touch with support/sales
    - General offer inquiries, business offers, or service proposals
    - Questions about pricing, products, or services
    - Requests for quotes, proposals, or business offers
    - General customer service requests
    - ANY mention of "offers" that is not explicitly about discount vouchers/coupons
    - Requests for product information or service details
    - Business-related offer requests (these are NOT vouchers)

    CRITICAL: "Offer" does NOT mean voucher unless explicitly mentioned as discount/coupon offer.

    DECISION PROCESS:
    1. Read ONLY the most recent user message (ignore all conversation history)
    2. Check if THIS SINGLE MESSAGE explicitly requests VOUCHERS/DISCOUNT CODES (not general offers)
    3. If YES and specifically about vouchers/discount coupons - call this tool with detected: true
    4. If NO or about business offers/general offers - do NOT call this tool

    When this tool is called, simply signal the voucher intent detection. The frontend will handle voucher generation automatically through its own endpoint. Do not wait for confirmation or ask for additional details - just acknowledge the voucher request briefly and continue the conversation normally.
    
    Extract the type of voucher request to signal the intent detection to the system.

    After calling the tool inform the user that you detected their request and will generate a voucher. (You do not send the voucher the frontend sends it after confirmation).
    `,
    zodSchema: zod_1.z.object({
        detected: zod_1.z.boolean().describe('Set to true when voucher request is detected')
    })
};
